import type { Book } from "@book-club/shared";
import { useQuery } from "@tanstack/react-query";
import booksService from "@/features/books/services/booksService";
import DURATIONS from "@/shared/constants/durations";
import { booksKeys } from "./booksQueryKeys";

export function useArchivedBooks({ enabled }: { enabled: boolean }) {
    return useQuery<Book[], Error>({
        enabled,
        gcTime: DURATIONS.ONE_DAY,
        queryFn: () => booksService.getArchivedBooks(),
        queryKey: booksKeys.archivedList(),
        staleTime: DURATIONS.FIVE_MINUTES,
    });
}
